import React from 'react';
import { RouterProvider } from '@providers/RouterProvider';
import { App as AntApp } from 'antd';
import { AntConfigProvider } from '@providers/AntConfigProvider';

export default function App() {
  return (
    <AntApp className="flex flex-col flex-1">
      <AntConfigProvider>
        <RouterProvider />
      </AntConfigProvider>
    </AntApp>
  );
}
